import _default from './Segment';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/elements/Segment/index.js
// module id = 880
// module chunks = 0